module.exports = __webpack_public_path__ + "img/activeliteracy.3fcb449a.png";